import React from "react";
import { Button, Col, Container, Row } from "reactstrap";

export default function AdminPageHeader({
  gradient = "dark",
  title,
  description,
  backAction,
  backLabel = "Listeye dön",
  primaryAction,
  primaryLabel,
  primaryTo,
  primaryColor = "secondary",
}) {
  return (
    <div className={`header bg-gradient-${gradient} pb-6 pt-5 pt-md-7`}>
      <Container fluid>
        <Row className="align-items-center py-2">
          <Col lg="7" xs="12">
            <h2 className="text-white mb-1">{title}</h2>
            {description ? <p className="text-white mb-0">{description}</p> : null}
          </Col>
          <Col lg="5" xs="12" className="text-right mt-3 mt-lg-0">
            {backAction ? (
              <Button color="secondary" size="sm" className={primaryAction || primaryTo ? "mr-2" : ""} onClick={backAction}>
                {backLabel}
              </Button>
            ) : null}
            {primaryTo ? (
              <Button color={primaryColor} size="sm" href={undefined} tag={primaryTo.tag || "a"} to={primaryTo.to} onClick={primaryTo.onClick}>
                {primaryLabel}
              </Button>
            ) : null}
            {!primaryTo && primaryAction ? (
              <Button color={primaryColor} size="sm" onClick={primaryAction}>
                {primaryLabel}
              </Button>
            ) : null}
          </Col>
        </Row>
      </Container>
    </div>
  );
}